<template>
	<component v-bind:is="iframeModal ? 'layout-blank' : 'layout-splash'">
		<form class="h-full flex flex-col">
			<div class="absolute top-0 right-0 pt-4 pr-4">
				<button
					type="button"
					class="p-2 rounded-md text-white md:text-gray-400 hover:bg-gray-100 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-orange-500"
					v-on:click="closeIframeModal()"
				>
					<span class="sr-only">{{ __("Close") }}</span>
					<ui-icon name="x" class="h-6 w-6" stroke-width="2" />
				</button>
			</div>

			<div>
				<div class="w-1/2">
					<h3 class="text-2xl md:text-4xl font-semibold">
						Preisindikation verschicken
					</h3>
				</div>

				<div class="w-1/2 flex flex-col space-y-3 gap-x-4 my-2">
					<div class="flex space-x-4 items-center">
						<ui-icon
							class="h-5 w-5 text-gray-400 flex-shrink-0"
							name="user"
							stroke-width="2"
						/>
						<span class="truncate"
							>{{ recipient.name }}<br />{{ recipient.company_name }}</span
						>
					</div>
					<div class="flex space-x-4 items-center">
						<ui-icon
							class="h-5 w-5 text-gray-400 flex-shrink-0"
							name="mail"
							stroke-width="2"
						/>
						<span class="truncate">{{ recipient.email }}</span>
					</div>
					<div class="flex space-x-4 items-center">
						<ui-icon
							class="h-5 w-5 text-gray-400 flex-shrink-0"
							name="phone"
							stroke-width="2"
						/>
						<span>{{ telephoneString }}</span>
					</div>
					<div
						class="flex space-x-4 items-center"
						v-if="recipient.tel_alternate"
					>
						<ui-icon
							class="h-5 w-5 text-gray-400 flex-shrink-0"
							name="phone"
							stroke-width="2"
						/>
						<span>{{ recipient.tel_alternate }}</span>
					</div>
					<div class="flex space-x-4 items-center">
						<ui-icon
							class="h-5 w-5 text-gray-400 flex-shrink-0"
							name="home"
							stroke-width="2"
						/>
						<span>{{ addressString }}</span>
					</div>
				</div>
			</div>

			<!--<div>
                <ui-input-group
                    class="col-span-8 md:col-span-4"
                    v-model="form.message"
                    field="message"
                    label="Message"
                    :form="form"
                    :required="true"
                ></ui-input-group>
            </div>-->
			<div
				class="border border-gray-300 rounded-lg shadow-sm md:overflow-hidden focus-within:border-orange-500 focus-within:ring-1 focus-within:ring-orange-500"
			>
				<ui-textarea
					class="block w-full max-w-prose py-2 border-0 resize-none focus:ring-0"
					:placeholder="__('Personal message')"
					v-model="form.message"
					@keydown="keydownHandler"
				/>
			</div>
			<div class="bg-gray-100 px-6 pt-4 pb-6">
				<div class="flex justify-between mt-4">
					<ui-button
						class="ml-auto"
						:disabled="submitButtonDisabled"
						v-on:click="submitForm()"
						label="Send"
					/>
				</div>
			</div>
		</form>
	</component>
</template>

<script>
import UiWizzard from "../../components/Ui/Wizzard.vue";
export default {
	mixins: [UiWizzard],
	props: {
		indication: {
			type: Object,
			required: true,
		},
		recipient: {
			type: Object,
			required: true,
		},
		iframeModal: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			form: Vue.observable(
				this.$inertia.form(Object.assign({ message: null }, this.indication))
			),
		};
	},
	computed: {
		telephoneString() {
			return this.recipient.tel_mobile || this.__("Not specified");
		},
		addressString() {
			let address = this.recipient.address;
			if (address) {
				return `${address.street}, ${address.zip} ${address.city}`;
			} else {
				return this.__("Not specified");
			}
		},
	},
	methods: {
		keydownHandler: function (e) {
			if (e.keyCode == 13 && e.shiftKey) {
				e.preventDefault();
				this.postMessage();
			}
		},
	},
};
</script>
